import { useTranslation } from "react-i18next";
import { NotificationItemGame } from "@/stores/notifications/notificationStore";
import { NotificationsGameItem } from "@/domains/notifications/components/NotificationsGameItem";

type Props = {
  item: NotificationItemGame;
  onClick?: () => void;
};

export default function NotificationsGameContainer({ item, onClick }: Props) {
  const { t } = useTranslation("notifications");

  return (
    <NotificationsGameItem
      type={item.data.type}
      text={t(`game.${item.data.type}`, item.data.payload)}
      onClick={onClick}
    />
  );
}
